/* jshint node: true */

/**
 * Mediaplayer plugin 
 * 
 * Requires jQuery 1.8 or higher
 * 
 * Written by James Brindle
 */
// we will move this to a compiled and cached script later
if (typeof 'mediaPlayer' == 'undefined') { mediaPlayer = []; }

(function ($) {

    'use strict';

    var mpCtrl;
    var $DOC = $(document);

    mpCtrl = {

        $mpUI: null,
        $MP: null,
        $mpShowName: null,
        $mpEpName: null,
        $mpWaveBox: null,
        $mpWaveNorm: null,
        $mpWaveOverlay: null,
        mpObj: null,
        episode: null,
        titlesPopulated: false,
        playerVisible: false,
        showID: null,
        episodeID: null,
        hasWaveform: false,

        hideTransportButtons: function() {
            this.$mpUI.find('.mp-transport').addClass('d-none');
        },

        clearTitles: function() {
            this.setShowName('Loading...');
            this.setEpisodeName('&nbsp;');
            this.titlesPopulated = false;
        },

        setShowName: function(name) {
            this.$mpShowName.html(name);
        },

        setEpisodeName: function(name) {
            this.$mpEpName.html(name);
        },

        setWaveForm: function(url) {
            if (url.normal && url.overlay) {
                this.$mpWaveNorm.attr('src', url.normal);
                this.$mpWaveOverlay.attr('src', url.overlay);
                this.$mpWaveBox.show();
                this.hasWaveform = true;
            } else {
                this.$mpWaveBox.hide();
                this.hasWaveform = false;
            }
        },

        setMediaTitle: function() {
            if (this.episode != null) {
                var mt = this.episode.show.title + " - " + this.episode.title;
                console.log(mt);
                this.$MP.attr('title', mt);
            }
        },

        clearMediaTitle: function() {
            this.$MP.removeAttr('title');
        },

        resetForLoading: function() {
            this.episode = null;
            this.hasWaveform = false;
            this.clearTitles();
            this.showLoadingIcon();
        },

        showPlayButton: function() {
            this.hideTransportButtons();
            this.$mpUI.find('.mp-transport.mp-play').removeClass('d-none');
        },

        showPauseButton: function() {
            this.hideTransportButtons();
            this.$mpUI.find('.mp-transport.mp-pause').removeClass('d-none');
        },

        showLoadingIcon: function() {
            this.hideTransportButtons();
            this.$mpUI.find('.mp-transport.mp-loading').removeClass('d-none');
        },

        evtPaused: function (e) {
            console.log('paused playback');
            this.showPlayButton();
        },

        evtEnd: function (e) {
            console.log('playback complete');
            this.mpObj.currentTime = 0;
            this.showPlayButton();
        },

        evtWaveformClicked: function(e, pos) {
            if (!this.hasWaveform) { return; }

            var reveal = Math.ceil(pos / this.$mpWaveBox.width() * 100);
            var inset = 100-reveal + "%";
            var playPos = Math.ceil((this.mpObj.duration / 100) * reveal);
            this.$mpWaveOverlay.css('clip-path', 'inset(0px ' + inset + ' 0px 0px)');
            this.mpObj.currentTime = playPos;            
        },

        evtTimeUpdate: function(e) {
            var timePlayed = this.mpObj.currentTime;
            var duration = this.mpObj.duration;
            if (timePlayed > 0) {
                var percPlayed = ((this.mpObj.currentTime / this.mpObj.duration) * 100);
                var inset = 100 - percPlayed + "%";
                this.$mpWaveOverlay.css('clip-path', 'inset(0px ' + inset + ' 0px 0px)');
            }
        },

        evtPlay: function (e) {
            console.log('unpause playback');
            this.showPauseButton();
        },

        evtError: function (e, msg) {
            console.log('loading error triggered');
            console.log(`Message: ${msg}`);
            this.setShowName('Error loading stream');
            if (msg !== 'undefined') {
                this.setEpisodeName(msg);
            }
        },

        evtPlayStarted: function (e) {
            console.log('playing event triggered');
            if (!this.titlesPopulated) {
                console.log('populating title area');
                this.setShowName(this.episode.show.title);
                this.setEpisodeName(this.episode.title);
                this.setMediaTitle();
                this.titlesPopulated = true;
            }
        },

        returnedFromAJAX: function(data) {
            this.episode = data;

            // var $S = mpCtrl.$MP.find('SOURCE:first');
            // $S.attr('src', data.player_url);
            this.mpObj.src = data.player_url;
            this.setWaveForm(this.episode.existing_waveform_url);
            this.showPlayButton();
            this.mpObj.load();
            window.setTimeout(function() {
                //mpCtrl.mpObj.play()
                mpCtrl.setShowName('Ready to play');
                mpCtrl.setEpisodeName("Tap the play button");

                mpCtrl.$mpUI.find('.mp-transport.mp-play').click();
            },500);
        },

        loadData: function() {
            var url = route('api.getplayercontent', [this.showID, this.episodeID]);
            console.log(url);

            this.setEpisodeName(this.showID + '/' + this.episodeID);

            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'json',
                success: function (data, txtStatus, jqXHR) {
                    if (data.error == true) {
                        // handle this better
                        console.log(data.message);
                        this.setShowName(data.message);
                    } else {
                        mpCtrl.returnedFromAJAX(data.data);                        
                    }
                }
            });

        },

        playButtonClicked: function(e, $OBJ) {
            e.preventDefault();
            e.stopPropagation();
            this.showID = $OBJ.data('show-id');
            this.episodeID = $OBJ.data('episode-id');
            console.log("Show: " + this.showID + ", Episode: " + this.episodeID);

            this.resetForLoading();

            if (!this.playerVisible) {
                this.$mpUI.fadeIn(500, function() {
                    mpCtrl.playerVisible=true;
                    mpCtrl.loadData();
                });
                this.$mpUI.removeClass('d-none');
            } else {
                this.loadData();
            }    
        },

        init: function() {
            console.log('player at ready');
            this.$mpUI = $('#mediaplayer');
            this.$MP = this.$mpUI.find('audio');
            this.mpObj = this.$MP[0];
            this.$mpShowName = this.$mpUI.find('.showname');
            this.$mpEpName = this.$mpUI.find('.episodename');
            this.$mpWaveBox = this.$mpUI.find('.waveform');
            this.$mpWaveNorm = this.$mpUI.find('.waveform > IMG.waveform-normal');
            this.$mpWaveOverlay = this.$mpUI.find('.waveform > IMG.waveform-overlay');

            $DOC.on('click', '.playbutton', function (e) {
                mpCtrl.playButtonClicked(e, $(this));
            });

            this.$MP.on('abort', function(e) {
                mpCtrl.evtError(e, 'Playback stopped');
            });
            
            this.$MP.on('error', function(e) {
                mpCtrl.evtError(e, 'Error event triggered');
            });

            this.$MP.on('ended', function(e) {
                mpCtrl.evtEnd(e);
            });

            this.$MP.on('pause', function (e) {
                mpCtrl.evtPaused(e);
            });

            this.$MP.on('play', function(e) {
                mpCtrl.evtPlay(e);
            });

            this.$MP.on('playing', function (e) {
                mpCtrl.evtPlayStarted(e);
            });

            this.$MP.on('timeupdate', function(e) {
                mpCtrl.evtTimeUpdate(e);
            });

            this.$mpUI.on('click', '.mp-transport.mp-pause', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (!mpCtrl.mpObj.paused) {
                    mpCtrl.mpObj.pause();
                }
            });

            this.$mpUI.on('click', '.mp-transport.mp-play', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (mpCtrl.mpObj.paused) {
                    mpCtrl.mpObj.play();
                }
            });

            this.$mpUI.on('click', '.waveform', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var posX = e.pageX - $(this).offset().left;
                mpCtrl.evtWaveformClicked(e, posX);
            });
        }
    }

    $(function () {
        // any init code
        mpCtrl.init();
    });

})(jQuery);
